export const apiUrl = "https://feed-what-fits.lernweiter.de/api";
